import { Stats } from '@react-three/drei'
import React from 'react'
import styled from 'styled-components'

const DebugStatsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`

const DebugStatsInstance = styled(Stats)`
  position: relative !important;
  display: block !important;
`

export const DebugStats: React.FC = () => {
  const debugStatsContainer = React.useRef(null)

  return (
    <DebugStatsContainer ref={debugStatsContainer}>
      <DebugStatsInstance parent={debugStatsContainer} showPanel={0} />
      <DebugStatsInstance parent={debugStatsContainer} showPanel={1} />
      <DebugStatsInstance parent={debugStatsContainer} showPanel={2} />
    </DebugStatsContainer>
  )
}
